<template>
  <div>
  </div>
</template>

<script>
/**
 * This component is used to CRM url redirect to given navigation
 * Intentionally created component to add further functionality  beofre CRM redirect
 */
import commonService from '../../services/common';
import axios from '../../axios-config';
import QRP from '../../../config/QRP.env';
import postData from '../../services/postData';

/* eslint-disable */
export default {
  props: ['callbackurl', 'quoteId', 'action', 'quotebundle', 'quadClickKey'],
  async created() {
    let apiURL = '';
    let sessId = '';
    if (this.callbackurl && this.callbackurl !== '') {
      apiURL = this.callbackurl;
      sessId = apiURL.slice(apiURL.indexOf('{'), apiURL.indexOf('}') + 1);
    } else if (this.quoteId && this.quoteId !== '') {
      sessId = this.quoteId;
      if (this.quotebundle && this.quotebundle === 'yes') {
        //Bundle quote
        apiURL = `/quotebundle/${this.action}/${this.quoteId}`;
      } else {
        //Monoline quote
        apiURL = `/navs/${this.action}/${this.quoteId}`;
      }
    }

    if (apiURL && apiURL !== '') {
      let clickKeyStatus;
      if ((!this.quotebundle || this.quotebundle && this.quotebundle !== 'yes') && apiURL.includes('/navs/openquote/')) {
        if (this.quadClickKey && this.quadClickKey !== '') {
          let requestBody = {
            "Quotes" : [
              {
              'QuoteId' : sessId
              },
            ],
            "VisitTrackerRequest" : {
              "QUADClickKey" : this.quadClickKey
            },
          };
          await this.callClickKeyTrackers(requestBody);
        }
      }

      return axios.get(apiURL)
      .then(async (response) => { // TODO: Refactor: Don't use this mixin method
        sessionStorage.removeItem('autobound');
        sessionStorage.removeItem('homebound');
        sessionStorage.removeItem('selectedQuote');
        sessionStorage.removeItem('flowType');
        sessionStorage.removeItem('currentNav');
        sessionStorage.removeItem('homeSessionData');
        sessionStorage.removeItem('condoSessionData');
        sessionStorage.removeItem('renterSessionData');
        sessionStorage.removeItem('autoSessionData');
        sessionStorage.removeItem('setRc2NavFlowAction');
        sessionStorage.removeItem('autoRC1BindResponse');
        sessionStorage.removeItem('checkoutNav');
        sessionStorage.removeItem('autoPageName');
        sessionStorage.removeItem('homeRC2pagename');
        sessionStorage.removeItem('selectedCarrierAuto');
        sessionStorage.removeItem('selectedCarrierHome');
        sessionStorage.removeItem('autoBindDetails');
        sessionStorage.removeItem('homeBindDetails');
        if (response.data.QuoteBundle && response.data.QuoteBundle.details) {
          let permalinkRequest = {qId:''};
          let flowType = '';
          for (let i = 0; i < response.data.QuoteBundle.details.length; i += 1) {
            if (response.data.QuoteBundle.details[i].productTypeId !== QRP.PRODUCTS.AUTO) {
              if (response.data.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.HOME) {
                flowType = 'bundle';
              } else if (response.data.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.CONDO) {
                flowType = 'cabundle';
              } else if (response.data.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.RENTERS) {
                flowType = 'rabundle';
              }
            }
          }
          sessionStorage.setItem('selectedQuote', JSON.stringify(response.data));
          sessionStorage.setItem('flowType', flowType);
          // sessionStorage.setItem('currentNav', 'homerc1');
          let sessionData = JSON.parse(sessionStorage.getItem('selectedQuote'));
          let bundleCallbackURL = '/navs/openquote/';
          let autoCallbackURL = '/navs/openquote/';
          let autoCallBackStatus;
          let autoSessID;
          for (let i = 0; i < response.data.QuoteBundle.details.length; i += 1) {
            sessionData.ProductTypeId = response.data.QuoteBundle.details[i].productTypeId;
            sessionData.SessionId = response.data.QuoteBundle.details[i].quoteId;
            if (response.data.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.HOME) {
              sessionStorage.setItem('homeSessionData', JSON.stringify(sessionData));
              permalinkRequest.qId = response.data.QuoteBundle.details[i].quoteId;
              sessId = response.data.QuoteBundle.details[i].quoteId;
            } else if (response.data.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.CONDO) {
              sessionStorage.setItem('condoSessionData', JSON.stringify(sessionData));
              permalinkRequest.qId = response.data.QuoteBundle.details[i].quoteId;
              sessId = response.data.QuoteBundle.details[i].quoteId;
            } else if (response.data.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.RENTERS) {
              sessionStorage.setItem('renterSessionData', JSON.stringify(sessionData));
              permalinkRequest.qId = response.data.QuoteBundle.details[i].quoteId;
              sessId = response.data.QuoteBundle.details[i].quoteId;
            }
            if (response.data.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.AUTO) {
              sessionStorage.setItem('autoSessionData', JSON.stringify(sessionData));
              autoSessID = response.data.QuoteBundle.details[i].quoteId;
              autoCallbackURL += response.data.QuoteBundle.details[i].quoteId;             
            }
          }            
          if (this.quadClickKey && this.quadClickKey !== '') {
            let requestBody = {
              "Quotes" : [
                {
                'QuoteId' : sessId
                },
                {
                'QuoteId' : autoSessID
                }
              ],
              "VisitTrackerRequest" : {
                "QUADClickKey" : this.quadClickKey
              },
            };
            clickKeyStatus = await this.callClickKeyTrackers(requestBody);
          } 
          autoCallBackStatus = this.callOpenQuoteCallBackURL(autoCallbackURL);            
          // set session id in store
          this.$store.dispatch('setSessionQuoteCRM', { SessionId: sessId });
          bundleCallbackURL += sessId;
          // actions.goToQuote(permalinkRequest, this.$store, this.$router);
          axios.get(bundleCallbackURL)
          .then((resp) => {
            if(resp.data.Navigate) {
              this.$store.dispatch('setCurrentNav', resp.data.Navigate);
              // set session id in store
              this.$store.dispatch('setSessionQuoteCRM', { SessionId: sessId });
              // identify route and redirect
              const routeName = commonService.getRouteName(resp.data.Navigate);
              this.$router.replace(routeName);
            }
          });
        } else if (response.data.Navigate) {
          this.$store.dispatch('setCurrentNav', response.data.Navigate);
          // set session id in store
          this.$store.dispatch('setSessionQuoteCRM', { SessionId: sessId });
          // identify route and redirect
          const routeName = commonService.getRouteName(response.data.Navigate);
          this.$router.replace(routeName);
        }
      });
    }
  },
  methods: {
    //this method is used to call clickkeytrackers
    async callClickKeyTrackers(requestBody) { 
      let clickResponse = false;     
      let requestParam = {
        url : '/autoquotes/reengagement/visittrackers',
        data: requestBody,
      }
      await postData.clickkeytrackers(requestParam).then((response) => {
        clickResponse = true
      });
      return clickResponse;
    },
    callOpenQuoteCallBackURL(callbackURL) {
      return axios.get(callbackURL)
        .then((resp) => {
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/interview/CrmImport.vue?cc50b89a